export enum BboxTypeEnum {
	POINT = 'point',
	CELL = 'cell',
	NONE = 'none',
}
